const DOCUMENT = 'APPLICANT_INTERVIEW_DETAILS_';

const actions = {
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',

  clearStore: payload => ({ type: actions.CLEAR_STORE, payload }),
  loadData: payload => ({ type: actions.LOAD, payload }),
  loadDataSuccess: payload => ({ type: actions.LOAD_SUCCESS, payload }),
};

export default actions;
